var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{attrs:{"name":"modal"}},[_c('div',{attrs:{"id":"loading"}}),_c('div',{attrs:{"id":"overlay"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }